import { Tag } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import { stringToColor } from '@/utils';

export const CTag = ({
  label,
  labelToColor = false,
  ...props
}: { label: string | ReactNode; labelToColor?: boolean } & Tag.RootProps) => {
  const { bg: propBg, color: propColor } = props;

  const useLabelColor = labelToColor && typeof label === 'string';
  const baseColor = useLabelColor ? stringToColor(label) : undefined;

  const bg = propBg ?? (baseColor && `${baseColor}.100`);
  const color = propColor ?? (baseColor && `${baseColor}.700`);

  return (
    <>
      {label && (
        <Tag.Root
          variant={props.variant ?? 'subtle'}
          size={props.size ?? 'lg'}
          borderRadius={props.borderRadius ?? 'xl'}
          fontWeight={props.fontWeight ?? 'semibold'}
          px={props.px ?? '3'}
          bg={bg}
          color={color}
          {...props}
        >
          <Tag.Label>{label}</Tag.Label>
        </Tag.Root>
      )}
    </>
  );
};
